import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { MenuIcon, X as CloseIcon, UserIcon, LogOutIcon, HomeIcon } from 'lucide-react';
const Header: React.FC = () => {
  const {
    user,
    isAuthenticated,
    logout
  } = useAuth();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const handleLogout = () => {
    logout();
    navigate('/');
  };
  return <header className="bg-white shadow-md sticky top-0 z-50" data-id="element-356">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-357">
        <div className="flex justify-between h-16" data-id="element-358">
          <div className="flex items-center" data-id="element-359">
            <Link to="/" className="flex-shrink-0 flex items-center" data-id="element-360">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iLjN9cDQjVbDSGqwWquEQb/1000138367.png" alt="Edo State Logo" className="h-12 w-auto" data-id="element-361" />
              <span className="ml-2 text-xl font-bold text-green-800 hidden sm:block" data-id="element-362">
                Edo State Services Portal
              </span>
            </Link>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-4" data-id="element-363">
            {isAuthenticated ? <>
                <Link to="/dashboard" className="text-gray-700 hover:text-green-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200" data-id="element-364">
                  Dashboard
                </Link>
                <Link to="/mdas" className="text-gray-700 hover:text-green-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200" data-id="element-365">
                  Services
                </Link>
                <div className="relative group" data-id="element-366">
                  <button className="flex items-center text-gray-700 hover:text-green-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200" data-id="element-367">
                    <span className="mr-1" data-id="element-368">{user?.name}</span>
                    <UserIcon size={16} data-id="element-369" />
                  </button>
                  <div className="absolute right-0 w-48 py-2 mt-2 bg-white rounded-md shadow-xl z-20 hidden group-hover:block transform transition-all duration-200 origin-top-right" data-id="element-370">
                    <Link to="/profile" className="block px-4 py-2 text-sm text-gray-700 hover:bg-green-100 transition-colors duration-150" data-id="element-371">
                      Profile
                    </Link>
                    <button onClick={handleLogout} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-green-100 transition-colors duration-150" data-id="element-372">
                      Logout
                    </button>
                  </div>
                </div>
              </> : <>
                <Link to="/login" className="text-gray-700 hover:text-green-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200" data-id="element-373">
                  Login
                </Link>
                <Link to="/register" className="bg-green-600 text-white hover:bg-green-700 px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 shadow-sm hover:shadow" data-id="element-374">
                  Register
                </Link>
              </>}
          </nav>
          {/* Mobile menu button */}
          <div className="flex items-center md:hidden" data-id="element-375">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-green-600 hover:bg-gray-100 focus:outline-none transition-colors duration-200" aria-expanded={isMenuOpen} data-id="element-376">
              <span className="sr-only" data-id="element-377">
                {isMenuOpen ? 'Close menu' : 'Open menu'}
              </span>
              {isMenuOpen ? <CloseIcon className="block h-6 w-6" aria-hidden="true" data-id="element-378" /> : <MenuIcon className="block h-6 w-6" aria-hidden="true" data-id="element-379" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu, show/hide based on menu state */}
      {isMenuOpen && <div className="md:hidden" data-id="element-380">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 border-t border-gray-200" data-id="element-381">
            {isAuthenticated ? <>
                <Link to="/dashboard" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-green-600 hover:bg-gray-100 transition-colors duration-150" onClick={() => setIsMenuOpen(false)} data-id="element-382">
                  Dashboard
                </Link>
                <Link to="/mdas" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-green-600 hover:bg-gray-100 transition-colors duration-150" onClick={() => setIsMenuOpen(false)} data-id="element-383">
                  Services
                </Link>
                <Link to="/profile" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-green-600 hover:bg-gray-100 transition-colors duration-150" onClick={() => setIsMenuOpen(false)} data-id="element-384">
                  Profile
                </Link>
                <button onClick={() => {
            handleLogout();
            setIsMenuOpen(false);
          }} className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-green-600 hover:bg-gray-100 transition-colors duration-150" data-id="element-385">
                  Logout
                </button>
              </> : <>
                <Link to="/login" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-green-600 hover:bg-gray-100 transition-colors duration-150" onClick={() => setIsMenuOpen(false)} data-id="element-386">
                  Login
                </Link>
                <Link to="/register" className="block px-3 py-2 rounded-md text-base font-medium text-green-600 hover:text-green-800 hover:bg-gray-100 transition-colors duration-150" onClick={() => setIsMenuOpen(false)} data-id="element-387">
                  Register
                </Link>
              </>}
          </div>
        </div>}
    </header>;
};
export default Header;